import React from 'react'
import styled from 'styled-components'
import { defaultCTAURI } from 'src/modules/utils/constants'
import { replaceUrlParam } from 'src/modules/utils/replaceUrlParam'
import { createUrl } from 'src/modules/utils/createUrl'
import { useSelector } from 'react-redux'
import { selectCTAParams } from 'src/modules/reducers/params'
import CTAButton from 'src/components/common/CTAButtonNew'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { fireUIInteractionEvent } from 'src/modules/analytics/v3'
import {
  body,
  colors,
  heading,
  mediaQuery,
  spacing,
  typographyMixin,
} from 'src/constants/marketing-ds'
import { SectionContainer } from '../SharedComponents'

const ExtraCTABanner = ({
  market,
  lang,
  ctaHrefOverride,
  ctaQuery,
  hasOfferInput,
  ctaText,
  hidden,
  disableFreeTrial = false,
  backgroundColor = null,
}) => {
  const parsedParams = useSelector(selectCTAParams)
  let ctaURL = createUrl(defaultCTAURI, parsedParams)
  const stateForProtobuf = useSelector(selectStateForProtobuf)

  ctaURL = replaceUrlParam(ctaURL, 'comp', 'extra_cta_banner')
  const defaultCtaText = useCtaText({ lang, market, disableFreeTrial, ctaText })
  const extraCTAText = {
    en: {
      headline: 'Ready to start streaming?',
      subtitle: (
        <>
          {' '}
          We’ll remind you the day before your trial ends.{' '}
          <span style={{ display: 'inline-block' }}>Watch TV, not the clock.</span>
        </>
      ),
    },
    es: {
      headline: '¿Listo para empezar a disfrutar?',
      subtitle: 'Te avisaremos un día antes de que termine tu prueba gratuita.',
    },
  }

  const ctaUrl = hasOfferInput ? '#' : ctaHrefOverride || ctaURL

  const handleOnClick = () => {
    const isAnchor = ctaUrl.startsWith('#')
    fireUIInteractionEvent(
      {
        element: defaultCtaText,
        component: 'extra_cta_banner_cta_clicked',
        type: isAnchor ? 'clicked_anchor' : 'clicked',
      },
      stateForProtobuf
    )
  }

  return (
    <SectionContainer backgroundColor={backgroundColor || colors.gradients.orange.medium}>
      <StyledExtraCTABanner>
        <div className="banner-content">
          <div className="banner-text">
            <h3>{extraCTAText[lang].headline}</h3>
            <h4>{extraCTAText[lang].subtitle}</h4>
          </div>
          <CTAButton onClick={handleOnClick} link={ctaUrl}>
            {defaultCtaText}
          </CTAButton>
        </div>
      </StyledExtraCTABanner>
    </SectionContainer>
  )
}

export default ExtraCTABanner

const StyledExtraCTABanner = styled.div`
  width: 100%;
  text-align: left;
  .banner-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 1440px;
    flex-direction: column;
    gap: ${spacing.md};
    padding: ${spacing.xl} 0;

    ${mediaQuery.tabletMax} {
      padding: ${spacing.xl} 0;
      flex-direction: row;
    }

    .banner-text {
      color: #fff;
      flex: 0 1 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${spacing.xxs};
      text-align: center;
      padding: 0;
      ${mediaQuery.tabletMax} {
        text-align: left;
        align-items: flex-start;
      }
      h3 {
        color: #fff;
        ${typographyMixin(heading.lg)}
        ${mediaQuery.tablet} {
          ${typographyMixin(heading.xl)}
        }
      }
      h4 {
        color: #fff;
        ${typographyMixin(body.lg)}
        ${mediaQuery.tablet} {
          ${typographyMixin(body.xl)}
        }
      }
    }
    .CTAButton {
      background: #fff;
      color: #000;
    }
  }
`
